import { APP_INITIALIZER, InjectionToken } from '@angular/core';
import { AppConfigService } from '../service/app-config.service';
import { AppConfigInitializer } from '../type/app-config.type';

export const APP_CONFIG_INITIALIZER = new InjectionToken<AppConfigInitializer>('APP_CONFIG');

function appConfigFactory(service: AppConfigService) {
  return () => service.loadConfig();
}

export const INIT_APP_CONFIG_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: appConfigFactory,
  deps: [AppConfigService],
  multi: true,
};
